import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import Multimedia from "@/pages/Multimedia";
import Opinion from "@/pages/Opinion";
import ArticleDetail from "@/pages/ArticleDetail";
import QuienesSomos from "@/pages/QuienesSomos";
import Contacto from "@/pages/Contacto";
import SearchResults from "@/pages/SearchResults";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminUsers from "@/pages/admin/AdminUsers";

const CATEGORIES = ["actualidad", "culturas", "historias", "sociedad", "mundo", "especiales"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            {/* Admin (no public layout) */}
            <Route path="/redaccion-nexodum/login" element={<AdminLogin />} />
            <Route path="/redaccion-nexodum" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/redaccion-nexodum/nuevo" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
            <Route path="/redaccion-nexodum/editar/:id" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
            <Route path="/redaccion-nexodum/mensajes" element={<ProtectedRoute><AdminContacts /></ProtectedRoute>} />
            <Route path="/redaccion-nexodum/usuarios" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />

            {/* Public site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              {CATEGORIES.map((c) => (
                <React.Fragment key={c}>
                  <Route path={`/${c}`} element={<CategoryPage category={c} />} />
                  <Route path={`/${c}/:slug`} element={<ArticleDetail />} />
                </React.Fragment>
              ))}
              <Route path="/multimedia" element={<Multimedia />} />
              <Route path="/multimedia/:slug" element={<ArticleDetail />} />
              <Route path="/opinion" element={<Opinion />} />
              <Route path="/opinion/:slug" element={<ArticleDetail />} />
              <Route path="/quienes-somos" element={<QuienesSomos />} />
              <Route path="/contacto" element={<Contacto />} />
              <Route path="/buscar" element={<SearchResults />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
